import React, { Component } from 'react';
import RequestAppointmentComponent from "./request-appointment.component";
import ActionBar from "./action-bar";
import AppointmentSplashPage from './appointment-splash-page.component';
import * as schedulerActions from '../../scheduler/mySchedule/mySchedule.actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './appointments.scss';

class RequestAppointmentContainerComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            appt: null,
            error: null
        }
    }

    handleSave = (appointment) => {
        const { schedulerActions } = this.props;
        const staffId = appointment.staffInvitees[0].calendarStaffId;
        schedulerActions.saveAppointment(staffId, appointment)
            .then(() => {
                this.handleModalOpen();
            })
            .catch((error) => console.log(error));
    }

    handleAppointment = (appointment, whenValidationError) => {
        this.setState({ appt: appointment, error: whenValidationError });
    }

    handleModalOpen() {
        this.setState({
            modalOpen: true
        });
    }

    render() {
        const { modalOpen, appt, error } = this.state;
        return (
            <section className='request-appointment-section'>
                {!modalOpen && <RequestAppointmentComponent handleAppointment={this.handleAppointment} />}
                {!modalOpen && <ActionBar handleSave={this.handleSave} appointment={appt} error={error} />}
                {modalOpen && <AppointmentSplashPage modalOpen={modalOpen} />}
            </section>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        schedulerActions: bindActionCreators(schedulerActions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(RequestAppointmentContainerComponent);



// WEBPACK FOOTER //
// src/dashboard/appointments/request-appointment-container.component.js